import { gql } from '@apollo/client';

export const GET_ADMIN_CONFIGS = gql`
  query GetAdminConfigs {
    adminConfigs {
      id
      key
      value
      description
      createdAt
      updatedAt
    }
  }
`;

export const GET_ADMIN_CONFIG = gql`
  query GetAdminConfig($key: String!) {
    adminConfig(key: $key) {
      id
      key
      value
      description
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_ADMIN_CONFIG = gql`
  mutation UpdateAdminConfig($input: UpdateAdminConfigInput!) {
    updateAdminConfig(input: $input) {
      id
      key
      value
      description
      createdAt
      updatedAt
    }
  }
`;

export const SEND_TEST_COFFEE_CHAT_EMAIL = gql`
  mutation SendTestCoffeeChatEmail($email: String!) {
    sendTestCoffeeChatEmail(email: $email)
  }
`;

export const GET_UNDELIVERED_EMAILS = gql`
  query GetUndeliveredEmails($limit: Float, $page: Float) {
    undeliveredEmails(limit: $limit, page: $page) {
      count
      page
      emails {
        id
        email
        subject
        errorMessage
        createdAt
      }
    }
  }
`;
